import { useAppDispatch, useAppSelector } from '../../state/hooks'
import { setOnboardingVisible } from '../../state/slices/onboardingSlice'
import { setActiveCompany } from '../../state/slices/companiesSlice'
import OnboardingWizard from './OnboardingWizard'

export default function OnboardingWizardHost() {
  const dispatch = useAppDispatch()
  const visible = useAppSelector((s) => s.onboarding.visible)
  if (!visible) return null
  return (
    <OnboardingWizard
      onClose={() => dispatch(setOnboardingVisible(false))}
      onComplete={(companyId: number) => {
        dispatch(setOnboardingVisible(false))
        dispatch(setActiveCompany(`company_${companyId}`))
      }}
    />
  )
}
